import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { Category } from './Category';
import { NoResults } from './NoResults';
import { NoResults2 } from 'Components/NoResults2';

interface ISearchCategories {
  value?: string | number;
  multiChoiceValue?: {
    value: string;
    searchValueID: number;
  }[];
  searchValueID: number;
}

interface IAdvancedSearchFilteredCategories {
  resultNumber: number;
  searchCategories: ISearchCategories[];
  removeSearchCategory: Function;
  maxSingleSearchFieldsID: number;
}

export const AdvancedSearchFilteredCategories = ({
  resultNumber,
  searchCategories,
  removeSearchCategory,
  maxSingleSearchFieldsID,
}: IAdvancedSearchFilteredCategories) => {
  const isDesktop = useIsDesktop();

  return (
    <>
      <Stack direction='column' gap='12px'>
        {resultNumber > 0 ? (
          <Typography fontWeight={400} fontSize='16px' component='h2'>
            {Dictionary[DICTIONARY.General].found}
            <strong> {resultNumber} </strong>
            {Dictionary[DICTIONARY.General].result}
          </Typography>
        ) : (
          <Typography
            margin={isDesktop ? '0 0 16px 0' : 0}
            variant={'body1'}
            tabIndex={0}
          >
            {Dictionary[DICTIONARY.General].searchResults}
          </Typography>
        )}

        <Stack
          direction='row'
          alignItems='center'
          gap={isDesktop ? '16px' : '12px'}
          flexWrap='wrap'
        >
          {searchCategories.map(
            (category: ISearchCategories, index: number) => {
              if (category.searchValueID < maxSingleSearchFieldsID) {
                return (
                  <Category
                    key={index}
                    searchValue={category.value}
                    removeSearchCategory={removeSearchCategory}
                    searchValueID={category.searchValueID}
                  />
                );
              } else {
                return category.multiChoiceValue?.map(
                  (
                    choice: { value: string; searchValueID: number },
                    index: number
                  ) => {
                    return (
                      <Category
                        key={index}
                        searchValue={choice.value}
                        removeSearchCategory={removeSearchCategory}
                        searchValueID={category.searchValueID}
                        subValueFieldID={choice.searchValueID}
                      />
                    );
                  }
                );
              }
            }
          )}
        </Stack>
      </Stack>
      {resultNumber === 0 && (
        <Stack position={'relative'} height={isDesktop ? '400px' : '200px'}>
          <NoResults2
            textSearch={Dictionary[DICTIONARY.General].changeFilter}
          />
        </Stack>
      )}
    </>
  );
};
